import { useSelector } from "react-redux";
import { getListOperatorFieldConditionsGroup, getListOperatorFieldValueGroup, IConditionSV2, IVConditionFilterV2 } from "../../../api/groupCustomerV2/groupCustomerV2Api";
import { ISelectOption } from "../../../api/selectOptions/selectOptionsApi";
import { convertNationwideTree } from "../../../api/unit/unitApi";
import { filterInfoOperatoToConditions } from "../../../apiSync/customerGroup/customerGroupApi";
import { mapToSelectOptions } from "../../../until";
import { OptionSelect_V2 } from "../../SystemConfiguration/AccountsManagement/Components/TreeSelectCustom_V2";
import { selectorInfoUser } from "../../../store/slices/infoUserSlice";


export const gListOperatorFieldConditionsGroupByInfo = async (
    data: IVConditionFilterV2, unitTemp: number
): Promise<IVConditionFilterV2> => {


    if (!Array.isArray(data.conditions) || data.conditions.length === 0) {
        return data;
    }

    const dataWithIsAdd: IVConditionFilterV2 = {
        ...data,
        conditions: data.conditions.map(cond => ({ ...cond, isAdd: true }))
    };

    const nextConditions = await Promise.all(
        dataWithIsAdd.conditions.map(async (cond) => {
            const fieldId = cond.CustomerField?.value;
            const inputType = cond.CustomerField?.inputType;
            if (!fieldId) return cond;

            try {
                // Luôn gọi lấy conditionData
                const operatorPromise = getListOperatorFieldConditionsGroup(fieldId).then((rs) =>
                    rs?.status && Array.isArray(rs.data) ? mapToSelectOptions(rs.data) : []
                );

                // Nếu là dropdown thì gọi thêm fetchDropdownOptions
                const dropdownPromise =
                    inputType === "dropdown"
                        ? fetchDropdownOptions(
                            fieldId, dataWithIsAdd,  unitTemp,
                            cond.condition?.value,

                        )
                        : Promise.resolve(undefined);

                // Với điều kiện kiểu string/number, gọi API để kiểm tra xem điều kiện
                // có cần nhập giá trị không (ví dụ: "Không trống" → API trả về value=null).
                // Không áp dụng cho date vì isAdd=true luôn bất kể value, tránh xóa mất
                // ngày người dùng đã chọn khi load lại.
                const needsValueCheck =
                    (inputType === "string" || inputType === "number") &&
                    !!cond.condition?.value;

                const valueCheckPromise = needsValueCheck
                    ? getListOperatorFieldValueGroup(
                        fieldId,
                        cond.condition!.value as number,
                        filterInfoOperatoToConditions(dataWithIsAdd),
                        unitTemp
                    )
                    : Promise.resolve(null);

                const [conditionData, optionsData, valueCheckResult] = await Promise.all([
                    operatorPromise,
                    dropdownPromise,
                    valueCheckPromise,
                ]);

                // Nếu API trả về value = null, điều kiện này không cần nhập giá trị
                // (ví dụ: "Không trống"). Đặt lại value = null để tránh hiển thị sai.
                // Chỉ áp dụng cho string/number, không áp dụng cho date.
                let correctedValue = cond.value;
                if (valueCheckResult?.status) {
                    const apiDefaultValue = valueCheckResult.data?.value;
                    if (apiDefaultValue === null || apiDefaultValue === undefined) {
                        correctedValue = null;
                    }
                }

                return {
                    ...cond,
                    isAdd: true,
                    conditionData,
                    value: correctedValue,
                    ...(inputType === "dropdown" ? { optionsData } : {}),
                };
            } catch {
                return cond;
            }
        })
    );


    return {
        ...data,
        conditions: nextConditions,
    };
};


//Lấy data Dropdown
export const fetchDropdownOptions = async (
    fieldId: number, infoOperator: IVConditionFilterV2,unitTemp:number,
    conditioId?: number
): Promise<ISelectOption[] | undefined> => {
    if (!conditioId) return undefined;
    try {
        const conditions = filterInfoOperatoToConditions(infoOperator)
        const rs = await getListOperatorFieldValueGroup(
            fieldId, conditioId, conditions, unitTemp
        );
        if (rs?.status && Array.isArray(rs.data.value)) {
            if (rs.data.type) {
                return convertNationwideTree(rs.data.value ?? []); // ép kiểu về ISelectOption
            } else {
                return rs.data.value as ISelectOption[]; // ép kiểu về ISelectOption
            }
        }
    } catch (e) {
        console.error("Lỗi fetchDropdownOptions:", e);
    }
    return undefined;
};